import MaintenanceCalculator from "@/components/MaintenanceCalculator";

export default function MaintenanceCalculatorPage() {
  return <MaintenanceCalculator />;
}
